module.exports = __webpack_public_path__ + "solanaproject/img/logo.11b4e5cb.svg";